import { type OwnedJob, type OwnedService } from "../../components/DashboardListingCards";
import { formatPhp } from "../../lib/money";
import { Wrench, Package, Building2, Briefcase, UserCheck, FolderKanban, Gavel, Send, MessageSquare, ClipboardCheck, Wallet, Bookmark, Settings, type LucideIcon, FileText } from "lucide-react";

export type OwnedProject = {
  ownerUserId?: number | null;
  ownerClosed?: boolean;
  moderationHidden?: boolean;
  id: string;
  title: string;
  category: string | null;
  location: string | null;
  detail?: { publicLocation?: string } | null;
  coverImage?: string | null;
  deadline: string | null;
  budget: number | null;
  bids: number;
  status: string;
  hidden: boolean;
  biddingClosed: boolean;
};

export type Mine = { jobs: OwnedJob[]; services: OwnedService[]; projects: OwnedProject[]; people: any[]; companies: any[]; rfqs: any[] };

export const peso = formatPhp;

// Desktop account navigation stays stable between the overview and focused workspaces.
export const nav = [
  ["My Services", Wrench], ["My Company", Building2],
  ["My Jobs", Briefcase], ["Hiring", UserCheck], ["My Items", Package], ["My Projects", FolderKanban], ["My Bids", Gavel], ["My Applications", Send], ["Messages", MessageSquare],
  ["Contracts", ClipboardCheck], ["Wallet / Escrow", Wallet], ["Saved Items", Bookmark], ["Settings", Settings],
] as const;

export const NAV_LINKS: Record<string, string> = { "Messages": "/messages", "Contracts": "/contracts", "Wallet / Escrow": "/wallet", "Saved Items": "/saved", "Settings": "/settings" };

export const NAV_VIEWS: Record<string, string> = {
  "My Résumés": "people", "My Services": "services", "My Jobs": "jobs",
  "My Projects": "projects", "My Company": "companies", "My Bids": "bids",
  "My Applications": "applications", "Hiring": "hiring", "My Items": "items",
};

export const MOBILE_LISTING_VIEWS = ["services", "companies", "jobs", "items", "projects", "bids", "applications"];

export const ALL_ACTIVITIES = ["find_work", "offer_service", "promote_company", "hire", "post_job", "post_project"];

export const ACTIVITY_ICONS: Record<string, LucideIcon> = {
  find_work: Briefcase, offer_service: Wrench, promote_company: Building2,
  hire: UserCheck, post_job: FileText, post_project: FolderKanban,
};
